module.exports = __webpack_public_path__ + "img/top_image2.135e8b9e.png";